import { type PropsWithChildren, type ReactElement } from 'react'
import { cn, PAGE_HEIGHT } from '@util'
import { PageHero } from './PageHero'
import { PageHeading } from './PageHeading'
import { PageFunctionBar } from './PageFunctionBar'
import { PageContent } from './PageContent'

type Props = PropsWithChildren<{
  className?: string
}>
const Page = ({ children, className }: Props): ReactElement => {
  return <div className={cn(PAGE_HEIGHT, 'relative flex w-full flex-col overflow-hidden', className)}>{children}</div>
}

Page.Content = PageContent
Page.Heading = PageHeading
Page.FunctionBar = PageFunctionBar
Page.Hero = PageHero

export { Page }
